import React from 'react'
import styled from 'styled-components'

const Root = styled.svg`
  width: ${({ $size }) => $size}rem;
`

export const StreamEmblem = ({ className, size }) => (
  <Root $size={size} className={className} viewBox="0 0 32 16">
    <path
      d="M20.906143,5.14421259 L31.1421525,4.41788454 C31.8178054,4.36994817 32.2432164,5.13212846 31.8481862,5.68287655 L24.6876726,15.6664461 C24.5375275,15.8757976 24.2957603,16 24.0382431,16 L7.98079374,16 C7.72367627,16 7.4822289,15.8761977 7.33192391,15.6672463 L0.152382405,5.68367682 C-0.243607273,5.13300876 0.181803807,4.36978811 0.858016344,4.41788454 L11.0628454,5.14429262 L15.4214502,0.266706849 C15.7408482,-0.0906952095 16.3004945,-0.0886144983 16.6172542,0.271268406 L20.906143,5.14421259 Z M23.049748,14.4171424 L16.4066674,11.9320537 L16.4066674,14.4171424 L23.049748,14.4171424 Z M15.6071728,14.4171424 L15.6071728,11.9320537 L8.96409216,14.4171424 L15.6071728,14.4171424 Z M14.8406174,11.338408 L3.05998438,6.92682138 L8.05330792,13.8744741 L14.8406174,11.338408 Z M17.1593915,11.338408 L23.946701,13.8744741 L28.9400245,6.92682138 L17.1593915,11.338408 Z M15.6135687,10.75853 L15.6135687,2.39663425 L10.0639569,8.66741584 L15.6135687,10.75853 Z M16.4066674,10.75853 L21.9563592,8.66741584 L16.4066674,2.39767461 L16.4066674,10.75853 Z M8.43650568,8.0893784 L9.71337848,6.65320794 L3.47516194,6.2056951 L8.43650568,8.0893784 Z M23.5170526,8.0893784 L28.4784763,6.2056951 L22.2402598,6.65320794 L23.5170526,8.0893784 Z"
      fill="#4D7CFE"
    />
  </Root>
)

StreamEmblem.defaultProps = {
  size: 2,
}
